



























import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'
import { getPhoneNumberPart, createSettingPhoneNumber } from './utils'

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue')
  }
})
export default class PhoneNumberInputGroup extends mixins(InputGroup) {
  @Prop(String) value!: string

  get disabled2() {
    return typeof this.phoneNumber1 !== 'string' || !this.phoneNumber1.trim()
  }

  get disabled3() {
    return typeof this.phoneNumber2 !== 'string' || !this.phoneNumber2.trim()
  }

  get phoneNumber1() {
    return getPhoneNumberPart(this.value, 1)
  }

  set phoneNumber1(value) {
    const newValue = createSettingPhoneNumber(value, this.value, 1)
    this.$emit('input', newValue)
  }

  get phoneNumber2() {
    return getPhoneNumberPart(this.value, 2)
  }

  set phoneNumber2(value) {
    const newValue = createSettingPhoneNumber(value, this.value, 2)
    this.$emit('input', newValue)
  }

  get phoneNumber3() {
    return getPhoneNumberPart(this.value, 3)
  }

  set phoneNumber3(value) {
    const newValue = createSettingPhoneNumber(value, this.value, 3)
    this.$emit('input', newValue)
  }
}
